/**
 * Skeleton — loading placeholder components.
 */

export function SkeletonLine({ className = '' }: { className?: string }) {
  return (
    <div className={`h-4 bg-surface-300 rounded-lg animate-pulse-slow ${className}`} />
  );
}

export function SkeletonCard({ rows = 3 }: { rows?: number }) {
  return (
    <div className="card space-y-3 animate-pulse-slow">
      <SkeletonLine className="w-1/3 h-3" />
      {Array.from({ length: rows }).map((_, i) => (
        <SkeletonLine key={i} className={i % 2 === 1 ? 'w-3/4' : 'w-full'} />
      ))}
    </div>
  );
}

export function SkeletonStatRow() {
  return (
    <div className="flex gap-3">
      {[1, 2, 3].map((i) => (
        <div key={i} className="flex-1 card-elevated animate-pulse-slow py-3 space-y-2">
          <div className="h-6 bg-surface-300 rounded-lg w-1/2 mx-auto" />
          <div className="h-3 bg-surface-300 rounded-lg w-2/3 mx-auto" />
        </div>
      ))}
    </div>
  );
}
